import { forwardRef, HTMLAttributes, memo } from "react"
import cn from "classnames"

import { Icon } from "components"
import { Spinner } from "components/Spinner"
import { ScreenShareSettingManual } from "modules/Call/components/ScreenShareSettingManual"

interface ScreenShareButtonProps extends HTMLAttributes<HTMLDivElement> {
    isHovered?: boolean
    isEnabled?: boolean
    lockToggle?: boolean
}

export const ScreenShareButton = memo(
    forwardRef<HTMLButtonElement, ScreenShareButtonProps>(
        ({ lockToggle, isHovered, isEnabled }, ref) => (
            <button
                ref={ref}
                className={cn("video-controls__button is-rounded", {
                    "is-hovered": isHovered,
                    "is-enabled": isEnabled,
                })}
                type="button"
            >
                {lockToggle ? (
                    <Spinner className="is-small" />
                ) : (
                    <Icon className="video-controls__icon" type="call-screenshare" size={32} />
                )}
            </button>
        )
    )
)

ScreenShareButton.displayName = "ScreenShareButton"

interface Props extends HTMLAttributes<HTMLDivElement> {
    onClose?: () => void
}

export const ScreenSharePopover = forwardRef<HTMLDivElement, Props>((props, ref) => {
    return (
        <div className="video-controls__overlay video-controls__content" {...props} ref={ref}>
            <ScreenShareSettingManual onClose={props.onClose} />
        </div>
    )
})

ScreenSharePopover.displayName = "ScreenSharePopover"
